import { createAsyncThunk } from '@reduxjs/toolkit';
import { deleteAsset, getAssetsService, uploadAssetService } from 'api/services/AssetsService';
import { convertBase64ImageToFile } from 'api/services/CharacterService';
import {
	uploadMusicVideoCroppedAudioAssetService,
	uploadVideoAnyoneImageAssetService,
} from 'api/services/MediaService.ts';
import { getImageDimensionsFromFileAsync } from 'core/utils/utils';

export const getAssetsAsync = createAsyncThunk('assets/getAssetsAsync', async ({ nextTs, type }) =>
	getAssetsService(nextTs, type),
);

export const uploadAssetsAsync = createAsyncThunk(
	'assets/uploadAssetsAsync',
	async ({ file, data }) => {
		try {
			const newAsset = await uploadAssetService(file, data);
			if (!newAsset?.id || !data?.type) {
				throw new Error();
			}
			return {
				value: newAsset,
				type: data.type,
			};
		} catch (e) {
			throw new Error('Failed to upload asset');
		}
	},
);

export const uploadInternalAssetsAsync = createAsyncThunk(
	'assets/uploadInternalAssetsAsync',
	async ({ file, data }) => {
		return uploadAssetService(file, data);
	},
);

export const deleteAssetsAsync = createAsyncThunk(
	'assets/deleteAssetsAsync',
	async ({ assetIds, type }) => {
		await deleteAsset(assetIds, type);
		return { assetIds, type };
	},
);

export const videoAnyoneImageUploadAsync = createAsyncThunk(
	'assets/videoAnyoneImageUploadAsync',
	async ({ videoAnyoneImage }) =>
		getImageDimensionsFromFileAsync(videoAnyoneImage)
			.then((imageDimensions) =>
				convertBase64ImageToFile(videoAnyoneImage).then((file) => ({ imageDimensions, file })),
			)
			.then((data) => {
				const { imageDimensions, file } = data;
				const [width, height] = imageDimensions;
				return uploadVideoAnyoneImageAssetService(file, {
					width,
					height,
					type: file.type,
				})
					.then(({ assetUrl, assetId }) => ({ assetUrl, assetId }))
					.catch((error) => {
						throw new Error(error?.message);
					});
			}),
);

export const musicVideoCroppedAudioUploadAsync = createAsyncThunk(
	'assets/musicVideoCroppedAudioUploadAsync',
	async (data) => {
		const { file, metadata } = data;
		return uploadMusicVideoCroppedAudioAssetService(file, { type: metadata?.type, metadata })
			.then(({ assetUrl, assetId }) => ({
				url: assetUrl,
				id: assetId,
				name: metadata?.name,
				duration: metadata?.metadata?.duration,
			}))
			.catch((error) => {
				throw new Error(error?.message);
			});
	},
);
